import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { ImageProp } from 'utilities/propTypes'

import styles from './styles.css'

class SearchResult extends Component {
  static propTypes = {
    className: PropTypes.string,
    image: ImageProp,
    title: PropTypes.node.isRequired,
    description: PropTypes.node,
    tag: PropTypes.string,
    selected: PropTypes.bool,
  }

  static defaultProps = {
    className: '',
    description: null,
    tag: '',
    selected: false,
    image: undefined,
  }

  getClassName() {
    return classnames(
      styles.root,
      this.props.className,
      this.props.selected && styles.selected,
    )
  }

  render() {
    const { image, title, description, tag, ...restProps } = this.props

    return (
      <div {...restProps} className={this.getClassName()}>
        {image && (
          <div className={styles.figure}>
            <img alt="" {...image} className={styles.avatar} />
          </div>
        )}

        <div className={styles.details}>
          <span className={styles.title}>{title}</span>
          <span className={styles.description}>{description}</span>
        </div>

        <div className={styles.tag}>{tag}</div>
      </div>
    )
  }
}

export default SearchResult



// WEBPACK FOOTER //
// ../source/components/SearchResult/index.js